import React, {Component} from 'react'
import ShopSettings from './ShopSettings'
import ShippingPaymentSettings from './ShippingPaymentSettings'
import StatusesSettings from "./StatusesSettings"
import IncomeStatusesSettings from "./IncomeStatusesSettings";
import CatalogSettings from "./CatalogSettings";

export default class CampaignsTab extends Component {
    constructor(props) {
        super(props)
        this.state = {}
    }

    render() {
        const {settings, statuses, campaign, context, api_url, type} = this.props

        return (
            <div key={campaign.id}>
                <ShopSettings type={type} campaign={campaign} settings={settings} context={context} api_url={api_url}/>
                <CatalogSettings type={type} campaign={campaign} settings={settings} context={context} api_url={api_url}/>
                {(type === 'DBS') && (<ShippingPaymentSettings campaign={campaign} context={context}/>)}
                <StatusesSettings type={type} statuses={statuses} settings={settings} campaign={campaign}/>
                <IncomeStatusesSettings type={type} statuses={statuses} settings={settings} campaign={campaign}/>
            </div>
        )
    }
}